import {isInPast} from '../../utils/date';

export function canAddEventDate(event = {}) {
  return isInPast(event.startTime);
}
